import { render, staticRenderFns } from "./create-diagnosis.vue?vue&type=template&id=3b3742a5&scoped=true"
import script from "./create-diagnosis.vue?vue&type=script&lang=js"
export * from "./create-diagnosis.vue?vue&type=script&lang=js"
import style0 from "./create-diagnosis.vue?vue&type=style&index=0&id=3b3742a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3742a5",
  null
  
)

export default component.exports